import { render, staticRenderFns } from "./tradingfrm.vue?vue&type=template&id=5d3fba8f"
import script from "./tradingfrm.vue?vue&type=script&lang=js"
export * from "./tradingfrm.vue?vue&type=script&lang=js"
import style0 from "./tradingfrm.vue?vue&type=style&index=0&id=5d3fba8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports